import { Pipe, PipeTransform } from '@angular/core';
import { ProductSplashViewModel } from '@models/api-search.models';
import { CampaignTypes } from '@features/product/product.models';

@Pipe({
    name: 'getSplashes',
    standalone: true
})
export class GetSplashesPipe implements PipeTransform {
    transform(
        activeSplashes: ProductSplashViewModel[] | undefined,
        priority: CampaignTypes[] = [
            'CampaignSplash',
            'CampaignSplash1',
            'ProductSplash',
            'ProductSplash1',
            'ProductSplash2'
        ]
    ): ProductSplashViewModel[] {
        return (
            activeSplashes
                ?.sort((a, b) => priority.indexOf(a.type as CampaignTypes) - priority.indexOf(b.type as CampaignTypes))
                .filter(splash => priority.includes(splash.type as CampaignTypes)) ?? []
        );
    }
}
